import moment from 'moment';
import compact from 'lodash.compact';
import { getTimeByEvent } from '@/helpers';

// TODO: reduce complexity of method below
// eslint-disable-next-line complexity
export default (menuFileContent, officeId, diets, events) => {
  const dataFromFile = menuFileContent.split('\r\n').filter((line) => line.trim() !== '');

  const rowDataFromFile = dataFromFile.map((row) => row.split('\t'));
  const minDataRows = 4;
  const minDataColumns = 3;

  const messagesTemplate = 'admin.menuParserMessages';

  if (rowDataFromFile.length < minDataRows) {
    throw new Error(`${messagesTemplate}.minDataRows`);
  }

  if (rowDataFromFile[2].length < minDataColumns) {
    throw new Error(`${messagesTemplate}.minDataColumns`);
  }

  const dates = rowDataFromFile[1].slice(2);
  const startDate = dates[0];
  const endDate = dates[dates.length - 1];

  dates.forEach((date) => {
    if (!date || date.split('-').length !== 3 || !moment(date).isValid()) {
      throw new Error(`${messagesTemplate}.dateFormat`);
    }
  });

  if (!rowDataFromFile[0][0] || rowDataFromFile[0][0].toLowerCase().trim() !== 'catering') {
    throw new Error(`${messagesTemplate}.firstRowFormat`);
  }

  if (!rowDataFromFile[2][0] || rowDataFromFile[2][0].toLowerCase().trim() !== 'event') {
    throw new Error(`${messagesTemplate}.thirdRowFormat`);
  }

  const eventsData = rowDataFromFile.slice(3);

  const normalizeString = (string) =>
    string
      .toLowerCase()
      .replace(/"/g, '')
      .trim();
  const sanitizeMealText = (meal) => {
    if (meal === '') return meal;
    meal = meal.replace(/"/g, '');
    meal = meal.replace(/[\u200B\u200D\uFEFF\u200E\u200F]/g, '');
    return meal.trim();
  };
  /* eslint no-param-reassign: 0 */
  const extractEventsAndMeals = (eventDataAccumulator, currentEventData) => {
    const mealEvent = normalizeString(currentEventData[0]);
    const dietType = normalizeString(currentEventData[1]);

    const meals = currentEventData.slice(2);

    if (mealEvent && dietType) {
      if (!eventDataAccumulator[mealEvent]) {
        eventDataAccumulator[mealEvent] = [];
      }

      meals.forEach((meal, index) => {
        if (!eventDataAccumulator[mealEvent][index]) {
          eventDataAccumulator[mealEvent].push({});
        }

        if (meal) {
          const sanitized = sanitizeMealText(meal);
          const existing = eventDataAccumulator[mealEvent][index][dietType];

          if (!existing) {
            eventDataAccumulator[mealEvent][index][dietType] = sanitized;
          } else if (Array.isArray(existing)) {
            existing.push(sanitized);
          } else {
            eventDataAccumulator[mealEvent][index][dietType] = [existing, sanitized];
          }
        } else {
          throw new Error(`${messagesTemplate}.noMeal`);
        }
      });
    }
    return eventDataAccumulator;
  };

  const eventMeals = eventsData.reduce(extractEventsAndMeals, {});

  const getMeals = (eventMeal) =>
    diets.flatMap((diet) => {
      const key = diet.name.toLowerCase();
      const val = eventMeal[key];
      if (!val) return [];
      if (Array.isArray(val)) {
        return val.map((name) => ({ name, dietId: diet.id }));
      }
      return [{ name: val, dietId: diet.id }];
    });

  const getMenuEvents = () =>
    events.map((mealEvent) =>
      eventMeals[mealEvent.name.toLowerCase()].map((eventMeal, index) => ({
        office: officeId,
        date: dates[index],
        event: mealEvent.id,
        time: getTimeByEvent(mealEvent.name.toLowerCase()),
        mealsInfo: compact(getMeals(eventMeal)),
      }))
    );

  return {
    startDate,
    endDate,
    menuEvents: getMenuEvents().flat(),
  };
};



// WEBPACK FOOTER //
// ./src/utils/weeklyMenuParser.js